import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, getApi } from 'services/rotasp/api';
import { PATH_EDUCACAO_SEDUC_DOMINIOS_API } from 'services/rotasp/path';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { Types, EscolasProximasRequest } from './types';

import { escolasProximasSuccess, escolasProximasFailure } from './actions';

function* escolasProximasRequest(request: ReducerActionRotaSP) {
	const {
		token,
		payload,
	}: { token?: string; payload: EscolasProximasRequest } = request;

	const response: ApiResponse = yield call(
		getApi,
		token || '',
		PATH_EDUCACAO_SEDUC_DOMINIOS_API,
		`escolas-proximas`,
		payload,
	);

	if (response.status === 200) {
		yield put(escolasProximasSuccess(response));
	} else if (response.error) {
		yield put(escolasProximasFailure(response.message));
	}
}

export default all([
	takeLatest(Types.ESCOLAS_PROXIMAS_REQUEST, escolasProximasRequest),
]);
